
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function GlassCard({ 
  children, 
  className, 
  onClick 
}: GlassCardProps) {
  return (
    <div 
      onClick={onClick}
      className={cn(
        "bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl text-sm sm:text-base shadow-sm p-4 sm:p-5",
        onClick && "cursor-pointer hover:scale-[1.01] transition-transform",
        className
      )}
    >
      {children}
    </div>
  );
}
